import { ClipboardList } from "lucide-react";
import type { SidebarItem } from "@/types/navigation";

/**
 * Sidebar entries for the Measurement section.
 *
 * Reports are not individually listed here — that list is data (`GET
 * /reports`, see `useReports`), and the section has a single simple entry
 * point (this catalogue page, `ReportsListPage`) the same way the Dashboard
 * Library is one entry point onto many dashboards. Other Measurement pages
 * (beyond reports) add their own top-level entries here as they appear.
 */
export const REPORTS_NAV: SidebarItem[] = [
  {
    id: "reports-catalog",
    label: "Reports",
    href: "/measurement",
    basePath: "/measurement",
    icon: ClipboardList,
  },
];
